const ProfileImageSample = () => {
  return (
    <svg
      className="w-full h-full"
      viewBox="0 0 128 128"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <rect width="128" height="128" rx="64" fill="#E5E7EB" />
      <circle cx="64" cy="44" r="24" fill="#9CA3AF" />
      <path
        d="M32 100c0-17.67 14.33-32 32-32s32 14.33 32 32v4H32v-4z"
        fill="#9CA3AF"
      />
    </svg>
  )
}

export default ProfileImageSample
